import { Base } from '@studiometa/js-toolkit';

/**
 * Variant Selects
 */
export default class VariantSelects extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantSelects',
    refs: ['disabledBtn[]', 'json'],
  };

  /**
   * mounted
   */
  mounted() {
    this.updateOptions();
    this.productForm = document.querySelector('.main-add-to-cart form');
    [this.currentColor] = this.options;
  }

  /**
   * Changing variation
   * @param {object} props
   * @param {Event} props.event
   */
  onChange({ event }) {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();

    this.toggleAddButton(true, '');

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      this.updateURL(event.target.classList.contains('disabled'));
      if (!event.target.classList.contains('disabled')) {
        this.renderProductInfo();
      }
      this.updateShareUrl();
    }

    this.$update();
  }

  /**
   * Open Restock popup
   * @returns {void}
   */
  onDisabledBtnClick() {
    setTimeout(() => {
      document.querySelector('.restock-alerts-notify-button').click();
    }, 500);
  }

  /**
   * Update Options
   * @returns {void}
   */
  updateOptions() {
    this.options = Array.from(this.$el.querySelectorAll('select'), (select) => select.value);
  }

  /**
   * Update Master ID
   * @returns {void}
   */
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  /**
   * Update Gallery based on current variation
   * @returns {void}
   */
  async updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentColor === this.options[0]) return;

    const productGallery = document.querySelector('.product-gallery-grid');

    productGallery.style.height = `${productGallery.offsetHeight}px`;
    [this.currentColor] = this.options;
    this.currentColor = this.currentColor.toLowerCase();
    const variantImages = document.querySelectorAll(`[data-group="${this.currentColor}"]`);
    if (variantImages.length === 0 && productGallery === undefined) {
      return;
    }

    productGallery.classList.add('opacity-0');

    setTimeout(() => {
      productGallery.innerHTML = '';
      variantImages.forEach((image) => {
        productGallery.innerHTML += image.innerHTML;
      });
      productGallery.classList.remove('opacity-0');
    }, 500);
  }

  /**
   * Update URL with variant info
   * @param {boolean} disabled remove variant params after notify widget displayed
   * @returns {void}
   */
  updateURL(disabled) {
    if (!this.currentVariant || this.$el.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );

    if (disabled) {
      setTimeout(() => {
        window.history.replaceState({}, '', `${this.$el.dataset.url}`);
      }, 1000);
    }
  }

  /**
   * Update Share Url
   * @returns {void}
   */
  updateShareUrl() {
    const shareButton = document.querySelector(`#Share-${this.$el.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update variant input
   * @returns {void}
   */
  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Update variant statuses
   * @returns {void}
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.$el.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.$el.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Set Input Availability
   * @param {Array} listOfOptions
   * @param {Array} listOfAvailableOptions
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.textContent = input.getAttribute('value');
      } else {
        input.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  /**
   * Render Product Info
   * @returns {void}
   */
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.$el.dataset.originalSection
      ? this.$el.dataset.originalSection
      : this.$el.dataset.section;

    fetch(
      `${this.$el.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.$el.dataset.originalSection
          ? this.$el.dataset.originalSection
          : this.$el.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(`#price-${this.$el.dataset.section}`);
        const source = html.querySelector(
          `#price-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsSource = html.querySelector(
          `#variant-radios-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsDestination = document.querySelector(
          `#variant-radios-${this.$el.dataset.section}`,
        );

        const addToCartSource = html.querySelector('#main-add-to-cart');
        const addToCartDestination = document.querySelector('#main-add-to-cart');

        const stickyAddToCartSource = html.querySelector('#sticky-add-to-cart');
        const stickyAddToCartDestination = document.querySelector('#sticky-add-to-cart');

        const sizesBtnSource = html.querySelector('#sizes-btn');
        const sizesBtnDestination = document.querySelector('#sizes-btn');

        const panelStoresSource = html.querySelector('#panel-stores');
        const panelStoresDestination = document.querySelector('#panel-stores');

        if (panelStoresSource && panelStoresDestination) {
          panelStoresDestination.innerHTML = panelStoresSource.innerHTML;
        }

        if (sizesBtnSource && sizesBtnDestination) {
          sizesBtnDestination.innerHTML = sizesBtnSource.innerHTML;
        }

        const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);

        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (variantsSource && variantsDestination) {
          variantsDestination.innerHTML = variantsSource.innerHTML;
          variantsDestination.classList.toggle(
            'hidden',
            variantsSource.classList.contains('hidden'),
          );
        }

        if (addToCartSource && addToCartDestination) {
          addToCartDestination.innerHTML = addToCartSource.innerHTML;
        }

        if (stickyAddToCartSource && stickyAddToCartDestination) {
          stickyAddToCartDestination.innerHTML = stickyAddToCartSource.innerHTML;
          stickyAddToCartDestination.classList.toggle(
            'hidden',
            stickyAddToCartSource.classList.contains('hidden'),
          );
        }

        const price = document.querySelector(`#price-${this.$el.dataset.section}`);

        if (price) price.classList.remove('hidden');

        const addButtonUpdated = html.querySelector(`#ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        // publish(PUB_SUB_EVENTS.variantChange, {
        //   data: {
        //     sectionId,
        //     html,
        //     variant: this.currentVariant,
        //   },
        // });
        this.$root.$update();
      });
  }

  /**
   * Toggle add Button
   * @param  {boolean} disable
   * @param  {string}  text
   * @returns {void}
   */
  toggleAddButton(disable = true, text = '') {
    const productForm = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.dataset.ref = 'disabledBtn[]';
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('data-ref', 'disabledBtn[]');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  /**
   * Set Unvailable to btn
   */
  setUnavailable() {
    const button = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.querySelector(`#price-${this.$el.dataset.section}`);
    const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Get variant Data
   * @returns {Array}
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.$refs.json.textContent);
    return this.variantData;
  }
}
